import HMS from "../assets/HMS.png";
import restaurant from "../assets/restaurant.png";
import cloud_migration from "../assets/cloud-migration.png";

export const PROJECTS = [
    {
        id: 1,
        tag: "Development",
        title: "Healthcare Management System",
        description: "Built comprehensive and highly analytical and secured dashboards increasing staff efficiency by 90%",
        imageUrl: HMS
    },

    {
        id: 2,
        tag: "Development",
        title: "Restaurant Management System",
        description: "Developed real-time management system that increased restaurant operations by more than 85%.",
        imageUrl: restaurant
    },

    {
        id: 3,
        tag: "Cloud Infrastructure",
        title: "Enterprise Cloud Migration",
        description: "Successfully migrated 300+ workloads from one CRM to another for a non profit organization.",
        imageUrl: cloud_migration
    },
]